import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { useSiteContext } from '../../hooks/useSiteContext';
import PlantInformationComponent from '../../components/PlantInformation/PlantInformation';

const PlantInformation: React.FC = () => {
  const { currentSite, isInSiteContext } = useSiteContext();

  if (!isInSiteContext || !currentSite.siteId) {
    return (
      <Box>
        <Alert severity="warning" sx={{ mb: 3 }}>
          No site selected. Please select a site from the dashboard to view plant information.
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      <PlantInformationComponent 
        selectedSiteId={currentSite.siteId} 
        siteName={currentSite.siteName || ''} 
      />
    </Box>
  );
};

export default PlantInformation; 